import type { ReactElement } from "react";
import { Skeleton } from "@/components/atoms";
import "./SpaceFilters.scss";
import "./SpaceFiltersSkeleton.scss";

/** Loading placeholder matching SpaceFilters layout. */
export function SpaceFiltersSkeleton(): ReactElement {
  return (
    <div className="space-filters space-filters-skeleton" aria-hidden="true">
      <div className="space-filters__filter-container space-filters__filter-container--zones">
        <Skeleton
          variant="text"
          className="space-filters-skeleton__label"
        />
        <Skeleton
          borderRadius="sm"
          borderWeight="base"
          className="space-filters-skeleton__select"
        />
      </div>

      <div className="space-filters__filter-container space-filters__filter-container--sort">
        <Skeleton
          variant="text"
          className="space-filters-skeleton__label space-filters-skeleton__label--sort"
        />
        <Skeleton
          borderRadius="sm"
          borderWeight="base"
          className="space-filters-skeleton__select"
        />
      </div>
    </div>
  );
}
